import { AfterViewChecked, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from 'src/app/modules/auth/auth.module';
import { ProfileCompletionModalComponent } from '../profile-completion-modal/profile-completion-modal.component';
import { SurveyCompletionModalComponent } from '../survey-completion-modal/survey-completion-modal.component';
import { SignupSurveyService } from 'src/app/modules/auth/service/signup-survey.service';
import { firstValueFrom } from 'rxjs';
import { profileCompletionPage } from 'src/app/shared/utilities/constants';
import { MissingInfoModalService } from 'src/app/shared/services/missing-info-modal.service';
import { Router } from '@angular/router';
import { isProfileCompSubmitSession } from 'src/app/modules/auth/auth-constants';
import { ToastService } from 'src/app/shared/services/common/toast.service';

@Component({
  selector: 'app-missing-info-modal',
  templateUrl: './missing-info-modal.component.html',
  styleUrls: ['./missing-info-modal.component.scss'],
  standalone: true,
  imports: [
      CommonModule,
      AuthModule,
      ProfileCompletionModalComponent,
      SurveyCompletionModalComponent
  ]
})
export class MissingInfoModalComponent implements OnInit, AfterViewChecked {

  progressBar = {
    total: 3,
    completed: 1
  }

  modalType = profileCompletionPage.modalType;
  activeModal = this.modalType.profileCompletion;
  noOfSurvey = 0;
  @ViewChild(ProfileCompletionModalComponent) profileCompletionModal!: ProfileCompletionModalComponent;

  constructor(
    private surveyService: SignupSurveyService,
    private missingInfoModalService: MissingInfoModalService,
    private router: Router,
    private toast: ToastService
  ) {
    this.router.events.subscribe((event) => {
      if(window.location.href.includes(this.modalType.surveyCompletion)){
        this.activeModal = this.modalType.surveyCompletion;
        this.progressBar.completed = 2;
      }
    });
  }

  async ngOnInit(): Promise<void> {
    const userPref = await firstValueFrom(this.surveyService.getProfileInCompleteSurvey())
    this.progressBar.total = userPref.length + 1;
    this.noOfSurvey = userPref.length;

    this.toast.clearToast();
  }

  ngAfterViewChecked(): void {
    if(this.progressBar.total === 1 && this.noOfSurvey === 0 && this.profileCompletionModal.isProfileCompleted && window.location.href.includes(profileCompletionPage.modalType.surveyCompletion))
      this.missingInfoModalService.closeModal();
  }

  onAction(action: string): void {
    if(action === profileCompletionPage.action.submitted){
      localStorage.setItem(isProfileCompSubmitSession.key, 'true')
    }

    if(this.noOfSurvey === 0 || action === profileCompletionPage.action.skip) {
      this.missingInfoModalService.closeModal();
    } else if(action === profileCompletionPage.action.profileSubmitted) {
      this.openSurveyCompletionModal();
    } else if(action === profileCompletionPage.action.continue) {
      this.progressBar.completed += 1;
    }
  }

  openSurveyCompletionModal(): void {
    this.missingInfoModalService.openSurveyCompletionModal();
    this.activeModal = this.modalType.surveyCompletion;
    this.progressBar.completed = 2;
  }

}
